import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './app';

import stores from './redux/stores';
import {Provider} from "react-redux";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <React.StrictMode>
        <Provider store={stores}>
            <App/>
        </Provider>
    </React.StrictMode>
);
